import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component shows notifications to the user. Comes in few different variants
 * that indicate what type of notification is shown. Also has an option to
 * force interaction from the user side where you choose if it's dismissible
 * or not.
 */
var NotificationComponent = /** @class */ (function (_super) {
    __extends(NotificationComponent, _super);
    function NotificationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationComponent.prototype.mounted = function () {
        this.contentChanged();
    };
    NotificationComponent.prototype.contentChanged = function () {
        var contentElement = this.$refs.content;
        if (typeof this.content === 'string') {
            contentElement.innerHTML = this.content;
        }
        else if (this.content) {
            while (contentElement.firstChild) {
                contentElement.removeChild(contentElement.firstChild);
            }
            contentElement.appendChild(this.content);
        }
    };
    NotificationComponent.prototype.close = function () {
        return;
    };
    Object.defineProperty(NotificationComponent.prototype, "iconVariant", {
        get: function () {
            switch (this.variant) {
                case 'info':
                    return 'info-solid';
                case 'success':
                    return 'tick-solid';
                case 'alert':
                    return 'alert-solid';
                case 'error':
                    return 'close-solid';
                case 'cookie':
                    return 'no-icon';
                default:
                    return 'icon-content';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "iconToastVariant", {
        get: function () {
            switch (this.variant) {
                case 'info':
                    return 'info';
                case 'success':
                    return 'checked';
                case 'alert':
                    return 'alert';
                case 'error':
                    return 'close-circle';
                case 'cookie':
                    return 'no-icon';
                default:
                    return 'icon-content';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "isNotMessage", {
        get: function () {
            return this.variant !== 'message' && this.variant !== 'cookie';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "isAdHocToast", {
        get: function () {
            return !!this.label && !!this.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "shouldShowCloseIcon", {
        get: function () {
            return ((this.dismissible || this.isToastNotification) &&
                !this.isAdHocToast &&
                !this.hideCloseIcon);
        },
        enumerable: false,
        configurable: true
    });
    NotificationComponent.prototype.openUrl = function () {
        if (this.url) {
            window.location.href = this.url;
        }
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NotificationComponent.prototype, "dismissible", void 0);
    __decorate([
        Prop({ type: [String, Element], default: null }),
        __metadata("design:type", Object)
    ], NotificationComponent.prototype, "content", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NotificationComponent.prototype, "variant", void 0);
    __decorate([
        Prop({
            type: String,
        }),
        __metadata("design:type", Object)
    ], NotificationComponent.prototype, "uniqueId", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], NotificationComponent.prototype, "isToastNotification", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], NotificationComponent.prototype, "hideCloseIcon", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NotificationComponent.prototype, "progressVariant", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NotificationComponent.prototype, "label", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NotificationComponent.prototype, "url", void 0);
    __decorate([
        Watch('content'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationComponent.prototype, "contentChanged", null);
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationComponent.prototype, "close", null);
    NotificationComponent = __decorate([
        Component({
            name: 'ui-notification',
        })
    ], NotificationComponent);
    return NotificationComponent;
}(Mixins(MagicConfigMixin)));

export default NotificationComponent;
